import defaultSchema from './default.schema';

export default {
  ...defaultSchema,
  title: 'Kontener na punkty',
  type: 'object',
  properties: {
    name: {
      title: 'Nazwa',
      type: 'string',
      fieldRequired: true
    },
    partnerId: {
      type: 'number',
      fieldRequired: true
    }
  }
};
